import counterUp from 'counterup2'

export function counter() {
	const callback = (entries) => {
		entries.forEach((entry) => {
			const el = entry.target
			if (entry.isIntersecting) {
				// Only start counter if not already running
				if (!el.classList.contains('counting')) {
					el.classList.add('counting')
					counterUp(el, {
						duration: 1000,
						delay: 16,
					})
				}
			} else {
				// Reset counting state when element leaves viewport
				el.classList.remove('counting')
			}
		})
	}

	const IO = new IntersectionObserver(callback, { threshold: 0.1 })

	document.querySelectorAll('.count').forEach((el) => {
		if (el) {
			IO.observe(el)
		}
	})
}
